<script lang="ts">
	let className: string = '';
	export { className as class };
</script>

<div class="flex w-full flex-row items-center justify-between">
	<svg aria-hidden="true" viewBox="0 0 42 10" fill="none" class={className}>
		<circle fill="#ED6A5E" cx="5" cy="5" r="4.5" />
		<circle fill="#F4BF4F" cx="21" cy="5" r="4.5" />
		<circle fill="#61C554" cx="37" cy="5" r="4.5" />
	</svg>
	<enhanced:img
		src="/static/images/meeko/meeko-text-logo.png"
		alt="meeko.ai"
		class="mr-12 mt-2 h-3.5 w-auto"
	/>
	<div />
</div>
